import Moderation from './Moderation';

export default Moderation;
